export default {"src":"/_next/static/media/icon-marketplace-godiverse.09882596.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};